import { useEffect } from "react";

/**
 * Radix Dialog/AlertDialog lock <body> with pointer-events:none while open
 * (to trap interaction behind the modal), and can leave it stuck that way
 * when two of them close in the same tick — a known Radix issue when
 * closing nested/sibling modals together (e.g. a confirm dialog inside a
 * form dialog). That freezes the whole page until a manual reload.
 *
 * This watches <body>'s style and clears the lock whenever no Radix
 * dialog/alertdialog is actually open, so it's a no-op the rest of the time.
 */
export const useReleaseStuckPointerEvents = () => {
  useEffect(() => {
    const clearIfStuck = () => {
      if (document.body.style.pointerEvents !== "none") return;
      const hasOpenOverlay = document.querySelector(
        '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]'
      );
      if (!hasOpenOverlay) {
        document.body.style.pointerEvents = "";
      }
    };

    const observer = new MutationObserver(clearIfStuck);
    observer.observe(document.body, { attributes: true, attributeFilter: ["style"] });
    clearIfStuck();

    return () => observer.disconnect();
  }, []);
};
